import { Typography } from 'src/components/PulseUI';

const InfoUnavailable = () => {
  return (
    <div className="flex items-center px-2 h-8 mx-2 mb-2">
      <Typography variant="body2" className="text-[#3f4148] font-medium">
        Not available
      </Typography>
    </div>
  );
};

export default InfoUnavailable;
